var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_361_1",
    "data-name": "Componente 361 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_11759",
    "data-name": "Rettangolo 11759",
    width: 37,
    height: 37,
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32910",
    "data-name": "Tracciato 32910",
    d: "M11,0H26A11,11,0,0,1,37,11V26A11,11,0,0,1,26,37H11A11,11,0,0,1,0,26V11A11,11,0,0,1,11,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close",
    "data-name": "Icon ionic-ios-close",
    d: "M22.56,20.4l6.511-6.511a1.526,1.526,0,1,0-2.158-2.158L20.4,18.243l-6.511-6.511a1.526,1.526,0,1,0-2.158,2.158L18.245,20.4l-6.511,6.511a1.526,1.526,0,0,0,2.158,2.158L20.4,22.559l6.511,6.511a1.526,1.526,0,1,0,2.158-2.158Z",
    transform: "translate(-1.285 -2.289)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.f07c818f4cd56b344a6614e5a445db4e.svg";
export { ForwardRef as ReactComponent };